import { SET_SETTINGS, SET_CREDENTIAL, SET_DRIVERS_BY_SHOP } from '../types/dispatch'

const initState = {
  lastModified: new Date().getTime(),
  msDispatchSettingsList: [],
  disabledShopList: [],
  driverList: {},
  msDispatchCredential: {},
}

export default (state = initState, action) => {
  switch (action.type) {
    case SET_SETTINGS:
      return {
        ...state,
        msDispatchSettingsList: action.payload.settingsList,
        lastModified: new Date().getTime(),
      }
    case SET_CREDENTIAL:
      return { ...state, msDispatchCredential: action.payload, lastModified: new Date().getTime() }
    case SET_DRIVERS_BY_SHOP:
      return { ...state, driverList: action.payload, lastModified: new Date().getTime() }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/dispatch.js